/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectAmountsResource
 */
export interface ProjectAmountsResource {
    /**
     * 
     * @type {number}
     * @memberof ProjectAmountsResource
     */
    totalExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectAmountsResource
     */
    totalIncludingTaxes: number;
}

/**
 * Check if a given object implements the ProjectAmountsResource interface.
 */
export function instanceOfProjectAmountsResource(value: object): value is ProjectAmountsResource {
    if (!('totalExcludingTaxes' in value) || value['totalExcludingTaxes'] === undefined) return false;
    if (!('totalIncludingTaxes' in value) || value['totalIncludingTaxes'] === undefined) return false;
    return true;
}

export function ProjectAmountsResourceFromJSON(json: any): ProjectAmountsResource {
    return ProjectAmountsResourceFromJSONTyped(json, false);
}

export function ProjectAmountsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectAmountsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'totalExcludingTaxes': json['totalExcludingTaxes'],
        'totalIncludingTaxes': json['totalIncludingTaxes'],
    };
}

export function ProjectAmountsResourceToJSON(value?: ProjectAmountsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalExcludingTaxes': value['totalExcludingTaxes'],
        'totalIncludingTaxes': value['totalIncludingTaxes'],
    };
}

